import React from 'react';
import ReviewerProjects from '../../components/reviewerProjects/ReviewerProjects';

export default function reviewerPage() {
  return (
    <div>
      <ReviewerProjects />
    </div>
  )
}